
import { ErrorComponent } from './error/error.component';
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse
} from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private dialog: MatDialog) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse | any) => {
        console.log('Error: ', error);
        // Default Unknown Error Message
        let errorMessage =
          'Front End Error: An unknown server has error occurred';
        let statusCode = 200;
        let statusText = 'OK';

        // Show Returned Error Messsage if there is one
        if (error) {
          errorMessage = error.error.errors;
          statusCode = error.status;
          statusText = error.statusText;

          this.dialog.open(ErrorComponent, {
            data: {
              statusCode: statusCode,
              statusText: statusText,
              message: errorMessage
            },
            width: '400px',
            height: '310px',
            backdropClass: 'dialog-backdrop-class',
            panelClass: 'participant-errors-panel-class'
          });
        }
        return throwError(
          () =>
            new Error(
              '\n \n Front End Error: \n \n Thrown Error from Angular App-Error-Interceptor: '
            )
        );
      })
    );
  }
}
